import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

import { MotesPaths, ProductTag } from '../../models';
import { DeviceService } from '../../providers/device.service';

@Component({
    selector: 'light-image',
    templateUrl: './light-image.component.html',
    styleUrls: ['./light-image.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LightImageComponent implements OnInit {

    @Output() imageLoaded = new EventEmitter<string>();

    @Input() set thumb(thumb: string) {
        this.thumbUrl = thumb;
        this.cd.markForCheck();
    }

    @Input() set thumbFallback(thumbFallback: string) {
        this.thumbFallbackUrl = thumbFallback;
        this.cd.markForCheck();
    }

    @Input() set image(image: string) {
        // Delay loading of big image 1 sec to let thumb load
        let delay = this.thumbUrl ? 300 : 0;
        if (delay > 0) this.blurOverride = true;
        setTimeout(() => {
            this.blurOverride = false;
            this.imageUrl = image;
            this.cd.markForCheck();
        }, delay);
    }

    @Input() set imageFallback(imageFallback: string) {
        this.imageFallbackUrl = imageFallback;
        this.cd.markForCheck();
    }

    @Input() set width(cssWidth: string) {
        this.cssWidth = cssWidth;
    }

    @Input() set height(cssHeight: string) {
        this.cssHeight = cssHeight;
    }

    @Input() alt: string = "Light Image Loader";
    @Input() set bgColor(color: string) {
        if(this.deviceService.isPlatformServer()) return;
        this.imageContainer.nativeElement.style.setProperty('--image-bg-color', color);
    }

    @Input() overlayIdx: number;
    @Input() set productTags(productTags: string) {
        // Add corresponding tag icon to overlay
        let tags = productTags.replace(/\s/g, "").toLowerCase().split(',');
        this.overlayIcons = tags.filter((tag) => tag in ProductTag);
    }

    @Input() hideLoadingIcon: boolean = false;

    @ViewChild('imageContainer', { static: true }) imageContainer: ElementRef<HTMLDivElement>;

    public thumbUrl = "";
    public thumbFallbackUrl = ""
    public imageUrl = "";
    public imageFallbackUrl = "";

    public cssHeight = "100%";
    public cssWidth = "100%";

    public thumbHasLoaded: boolean = false;
    public imageHasLoaded: boolean = false;
    public hideImageLoader: boolean = false;
    public overlayIcons: string[] = []; // TODO: remove elements

    private blurOverride: boolean = false;

    // Expose to view
    public MotesPaths = MotesPaths;

    constructor(private cd: ChangeDetectorRef, private deviceService: DeviceService) { }

    ngOnInit() {
    }

    // public thumbImgLoaded(ev: any) {
    //     this.thumbHasLoaded = true;
    //     this.thumbLoaded.emit(this.thumb);
    // }

    public imageImgLoaded() {
        // Force container to image height if defined as auto aka no height given
        // Show thumb hide animation when image has loaded
        // (but give thumb at least a sec to show off even if loaded)
        // .. unless no thumbnail is provided by user (then there is no reason to show off
        this.hideLoadingIcon = true;
        this.imageHasLoaded = false;
        this.cd.markForCheck();

        let thumbShowTime = this.thumbUrl ? 10 : 0;
        // This triggers css image zoom animation
        if (!this.blurOverride) setTimeout(() => {
            this.hideImageLoader = true;
            this.imageHasLoaded = true; // Set image has loaded to avoid change detection when
            this.imageLoaded.emit(this.image);
            this.cd.markForCheck();
        }, thumbShowTime);

        // // Hide thumb when real image has been loaded to save performance
        // setTimeout( () => {
        //     this.hideImageLoader = true;
        //     this.imageLoaded.emit(this.image);
        //     this.cd.markForCheck();
        // }, 1500);
    }
}
